export default __webpack_public_path__ + "static/media/my_resume.696d7506.pdf";